import { render, staticRenderFns } from "./AddNewService.vue?vue&type=template&id=e2aafca2&"
import script from "./AddNewService.vue?vue&type=script&lang=js&"
export * from "./AddNewService.vue?vue&type=script&lang=js&"
import style0 from "./AddNewService.vue?vue&type=style&index=0&id=e2aafca2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports